import React, { Component } from 'react'
import Button from 'components/Button'
import { store } from '../../store/index'

import closeBtn from 'assets/images/close.svg'
import noImage from 'assets/images/no-image.svg'
import { CONFIG_BASE_URL } from '../../utils/consts'

export default class ModalEventsInfo extends Component {
  state = {
    event: {},
  }

  render() {
    const { date, place, type, userInfo, screens, comment } = this.props
    const { access } = store.getState().tokenInfo

    return (
      <div className='modal-overlay'>
        <div className='modal modal--sm'>
          <div className='modal__header'>
            <p className='modal__title'>Информация о событии</p>
            <Button
              className='button--icon'
              icon={true}
              iconPicture={closeBtn}
              action={this.props.closeModal}
            />
          </div>
          <div className='modal__content events-info'>
            <div className='events-info__main'>
              <div className='main__desc'>
                <h4>{place}</h4>
                <p>{date}</p>
                <p>{type}</p>
                <p className='blue'>{userInfo.title}</p>
              </div>
              <div className='main__photo'>
                <img
                  src={
                    Object.keys(userInfo).length && userInfo.photo.length
                      ? CONFIG_BASE_URL +
                        `${userInfo.photo[0].url_path}?token=${access}`
                      : noImage
                  }
                  alt={
                    Object.keys(userInfo).length && userInfo.photo.length
                      ? `Фото сотрудника ${userInfo.title}`
                      : 'No photo'
                  }
                />
              </div>
            </div>
            <div className='events-info__screens'>
              <h4>Скриншот</h4>
              <div className='screens'>
                <img
                  src={
                    screens
                      ? CONFIG_BASE_URL +
                        `${screens}?token=${access}`
                      : noImage
                  }
                  alt={screens ? screens : 'No photo'}
                />
              </div>
            </div>
            <div className='events-info__comments'>
              <h4>Комментарий</h4>
              <p>{comment}</p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
